module.exports = __webpack_public_path__ + "static/media/logo-footer.8786b8aa.svg";